module.exports = __webpack_public_path__ + "img/sdk-2-0.944a838.svg";